export default {
  setActivities (state, activities) {
    state.hydrated = true
    state.activities = activities
  }
}



// WEBPACK FOOTER //
// ./~/vue-components/live-coach/store/mutations.js